import React, { useEffect, useRef, useState } from "react";
import CommonModal from "../../../Modals/CommonModal";
import { useDispatch, useSelector } from "react-redux";
import InfiniteDotLoader from "../../../../utils/InfiniteDotLoader";
import Icon from "../../../Layouts/Icons";

const ProjectEventInfoPopup = ({
  openEventInfoModal,
  setOpenEventInfoModal,
  setOpenShareModal,
  setOpenProjectInfoModal,
  handleGetEventShareInfoPopup,
}) => {
  const [isCopied, setIsCopied] = useState(false);

  const { getCurrentProjectDetails, allFolders } = useSelector(
    (state) => state.projectSinglePage
  );
  const copyTextToClipboard = async (text) => {
    if ("clipboard" in navigator) {
      return await navigator.clipboard.writeText(text);
    } else {
      return document.execCommand("copy", true, text);
    }
  };
  const handleCopyClick = (copyText) => {
    copyTextToClipboard(copyText)
      .then(() => {
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 1500);
      })
      .catch((err) => {});
  };
  const [loading, setLoading] = useState(false);
  return (
    <CommonModal
      backdrop="static"
      keyboard={false}
      showModal={openEventInfoModal}
      setShowModal={setOpenEventInfoModal}
      centered={true}
      className={"ProjectInfo__modal"}
      title={<h4>Event Info</h4>}
      content={
        <>
          <ul className={`${"ProjectInfo"} row`}>
            <li className={`${"ProjectInfo__item"} col-lg-6`}>
              <h5 className={"ProjectInfo__title"}>Event Name</h5>
              <span className={"ProjectInfo__content"}>
                {allFolders.eventInfo.data?.name}
              </span>
            </li>
            <li className={`${"ProjectInfo__item"} col-lg-6`}>
              <h5 className={"ProjectInfo__title"}>Event Category</h5>
              <span className={"ProjectInfo__content"}>
                {allFolders?.eventInfo?.data?.event_category?.name}
              </span>
            </li>
            <li className={`${"ProjectInfo__item"} col-lg-6`}>
              <h5 className={"ProjectInfo__title"}>Client Name</h5>
              <span className={"ProjectInfo__content"}>
                {allFolders.eventInfo.data?.project?.get_clients?.[0]?.["name"]}
              </span>
            </li>
            <li
              className={`${"ProjectInfo__item"} col-lg-6`}
              title={
                allFolders.eventInfo.data?.project?.get_clients?.[0]?.["email"]
              }
            >
              <h5 className={"ProjectInfo__title"}>Email Address</h5>
              <span className={"ProjectInfo__content"}>
                {
                  allFolders.eventInfo.data?.project?.get_clients?.[0]?.[
                    "email"
                  ]
                }
              </span>
            </li>
            <li className={`${"ProjectInfo__item"} col-lg-6`}>
              <h5 className={"ProjectInfo__title"}>Mobile Number</h5>
              <span className={"ProjectInfo__content"}>
                {
                  allFolders.eventInfo.data?.project?.get_clients?.[0]?.[
                    "mobile"
                  ]
                }
              </span>
            </li>
            <li className={`${"ProjectInfo__item"} col-lg-6`}>
              <h5 className={"ProjectInfo__title"}>Location</h5>
              <span className={"ProjectInfo__content"}>
                {allFolders.eventInfo.data?.project?.location_name}
              </span>
            </li>
            <li className={`${"ProjectInfo__item"} col-lg-6`}>
              <h5 className={"ProjectInfo__title"}>Date</h5>
              <span className={"ProjectInfo__content"}>
                {" "}
                {allFolders.eventInfo.data?.date}
              </span>
            </li>
            {allFolders.eventInfo.data?.lock_password != null && (
              <li className={`${"ProjectInfo__item"} col-lg-6`}>
                <h5 className={"ProjectInfo__title"}>Studio Password</h5>
                <span className={"ProjectInfo__content"}>
                  {" "}
                  {allFolders.eventInfo.data?.lock_password}
                </span>
              </li>
            )}

            {allFolders?.eventInfo?.data?.project?.password != null && (
              <li className={`${"ProjectInfo__item"} col-lg-6`}>
                <h5 className={"ProjectInfo__title"}>FPA Password</h5>
                <span
                  className={"ProjectInfo__content d-flex align-items-center"}
                >
                  {allFolders?.eventInfo?.data?.project?.password
                    ? allFolders?.eventInfo?.data?.project?.password
                    : allFolders?.eventInfo?.data?.project?.password > 50
                    ? allFolders?.eventInfo?.data?.project?.password.substring(
                        0,
                        25
                      ) + "...more"
                    : allFolders?.eventInfo?.data?.project?.password}
                  <div
                    className="ProjectInfo__copyLink"
                    onClick={() =>
                      handleCopyClick(
                        allFolders?.eventInfo?.data?.project?.password
                      )
                    }
                  >
                    <Icon icon={"icon-link"} size={15}></Icon>
                  </div>
                  {isCopied && (
                    <span className={"ProjectInfo__clipBoard"}>copied</span>
                  )}
                </span>
              </li>
            )}
          </ul>
        </>
      }
    />
  );
};

export default ProjectEventInfoPopup;
